<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div *ngIf="carregando" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2">Carregando informações...</p>
      </div>

      <div *ngIf="!carregando">
        <app-form-scripts-marketing [empresa]="empresa" [usuario]="usuario"></app-form-scripts-marketing>
      </div>
    </div>
  </div>
</div> 